import type { AppThunk } from "@Store/index";
import getBlogHomeData from "../BlogHome/data/getBlogHomeData";
import { fetchBlogPageDataIfNeeded } from "../BlogPost/data/blogPageReducer";
import { getBlogLanguageFromPath } from "../utils/blogLanguage";

/**
 * Centralized loadData function for all blog pages
 * Handles blog home, category pages, tag pages, search pages, latest page, and individual blog posts
 * Supports language-prefixed routes (e.g., /fr/blog, /de/blog/post/:slug)
 */
const loadData = (props: any): AppThunk[] => {
  const path = __SERVER__ ? props?.req?.path : window.location.pathname;
  const queryString = __SERVER__ ? props?.req?.query : new URLSearchParams(window.location.search);

  const validLang = getBlogLanguageFromPath(path);

  // Strip language prefix from path before matching blog page type
  const blogPath = validLang ? path.replace(`/${validLang}`, "") : path;

  // Check if this is the blog home page
  const isBlogHome = blogPath === "/blog";

  if (isBlogHome) {
    // For blog home page, use the home data loader
    return [getBlogHomeData({ staticContext: props?.staticContext, lang: validLang })];
  }

  // For all other blog pages (category, tag, search, latest, or single blog post)
  // Determine the page type
  const isCategory = blogPath.includes("/category/");
  const isTag = blogPath.includes("/tag/");
  const isLatest = blogPath.includes("/latest");
  const isSearch = blogPath.includes("/search");
  const isDraft = blogPath.includes("/drafts-blog/");
  const searchQuery = __SERVER__
    ? queryString?.query || queryString?.q || ""
    : queryString.get("query") || queryString.get("q") || "";

  return [
    fetchBlogPageDataIfNeeded(
      props,
      isCategory,
      isTag,
      isSearch,
      searchQuery,
      isLatest,
      isDraft,
      validLang,
    ),
  ];
};

export default loadData;
